import * as s from "./AuthBrand.style.css";

export function AuthBrand() {
  return (
    <div className={s.root}>
      <img
        src="/logos/lion_energy_lion.svg"
        alt=""
        width={26}
        height={26}
        className={s.logo}
      />
      <img
        src="/logos/lion_energy_wordmark.png"
        srcSet="/logos/lion_energy_wordmark@2x.png 2x, /logos/lion_energy_wordmark@3x.png 3x"
        alt="Lion Energy"
        className={s.wordmark}
      />
    </div>
  );
}
